import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import classNames from 'classnames'

import { getUserImage } from './../../libs/utils'
import { Link } from 'react-router-dom'

class MainMenuLoggedIn extends Component {
  render() {
    const userMenuClass = classNames({
      'main-header__user-menu': true,
      'main-header__dropdown-menu': true,
      hidden: this.props.userMenuCollapsed
    })

    const userProfileImage = getUserImage(this.props.user)

    return (
      <div>
        <div className="flex">
          <div className="main-header__links">
            <a href="#">{this.props.t('help')}</a>
            <a href="#" onClick={this.props.setChatOnTop}>
              {this.props.t('messages')}
            </a>
          </div>
          <img className="main-header__profile-pic" src={userProfileImage} alt="Profile" onClick={this.props.showUserMenu} />
          <div className="main-header__dropdown-menu-wrapper">
            <ul className={userMenuClass}>
              <li>
                <Link to="/profile">{this.props.t('my_profile')}</Link>
              </li>
              <li>
                <Link to="/trip-guru-orders">{this.props.t('my_orders')}</Link>
              </li>
              <li>
                <Link to="/review">{this.props.t('reviews')}</Link>
              </li>
              <li>
                <Link to="/settings">{this.props.t('settings')}</Link>
              </li>
              <li>
                <a href="#" onClick={this.props.handleLogoutClick}>
                  {this.props.t('logout')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('main'))
export default enhance(MainMenuLoggedIn)



// WEBPACK FOOTER //
// src/components/Navbar/MainMenuLoggedIn.jsx